import React from "react";

export default function Audience({ register, errors }) {
  const fieldName = "audience";

  return (
    <div>
      <label className="wdc-field-label" htmlFor={fieldName}>
        Your target audience
      </label>
      <textarea
        id={fieldName}
        className="wdc-field"
        rows="4"
        placeholder="Who are your ideal customers?"
        {...register(fieldName, { required: true })}
      />
      {errors[fieldName] && (
        <span className="wdc-error">This field is required</span>
      )}
    </div>
  );
}
